const GLOBAL_POSTAL_CODE_REGEX = /^(?:\s*[A-Za-z0-9-]\s*){4,10}$/;

export function validateEmail(email) {
  return /^[A-Z0-9'._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)
}

/**
 * validates zipcode with provided countryCode
 * APAC will be short circuit scenario (Asia Pacific)
 * @param  {String} zipcode          Zipcode to validate
 * @param  {String} [countryCode='US'] User's set countryCode
 * @param  {Boolean} [isApac=false]    whether user is in APAC
 * @param  {Boolean} [isEMEA=false]    whether user is in isEMEA
 * @return {Boolean}                 Whether zipcode is valid
 */
export function validateDunsNumber({ dunsNumber }) {
  const DUNSNUMBER_REGEX = /^[0-9]{9}$/
  return DUNSNUMBER_REGEX.test(dunsNumber)
}

export function validateZipcode({
  zipcode,
  countryCode,
  isApac = false,
  isEMEA = false,
}) {
  const ZIPCODE_REGEX_US = /^(\d{5})(-\d{4})?$/
  const ZIPCODE_REGEX_CA = /^[a-z][0-9][a-z]\s*?[0-9][a-z][0-9]$/i
  //if country code is provided, it will take precendence over region flags
  //because a specific country logic is being asked for
  if (!countryCode && (isApac || isEMEA)) {
    return true
  }
  switch (countryCode) {
    case 'US':
      return ZIPCODE_REGEX_US.test(zipcode)
    case 'CA':
      return ZIPCODE_REGEX_CA.test(zipcode)
    default:
      return true
  }
}

export function validateGlobalZipcode(zipcode) {
  return GLOBAL_POSTAL_CODE_REGEX.test(zipcode);
}

/**
 * validates phone number base on region
 * APAC will be short circuit scenario (Asia Pacific)
 * @param  {String} phoneNumber          phoneNumber to validate
 * @param  {Boolean} [isApac=false]    whether user is in APAC
 * @param  {Boolean} [isEMEA=false]    whether user is in isEMEA
 * @return {Boolean}                 Whether phoneNumber is valid
 */
export function validatePhoneNumber({
  phoneNumber,
  isAPAC = false,
  isEMEA = false,
}) {
  if (isAPAC) {
    const apacRegexPhone = /^\+?\d(?:[\s.]?\d){5,12}$/
    return apacRegexPhone.test(phoneNumber)
  }
  //determine regex validation by region
  const phoneExpression = isEMEA
    ? /^(?=.*[0-9])[- +()0-9]{9,20}$/
    : /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
  return phoneExpression.test(phoneNumber)
}
